// AppSync pipeline resolvers can't loop pages, so cursor pagination is followed client-side.

const MAX_FETCH_PAGES = 100;

export interface CursorPage<T> {
    items: T[];
    pageInfo: {
        cursor: string | null;
        hasNextPage: boolean;
    };
}

export async function fetchAllPages<T>(fetchPage: (cursor: string | null) => Promise<CursorPage<T>>): Promise<T[]> {
    const items: T[] = [];
    const seenCursors = new Set<string>();
    let cursor: string | null = null;

    for (let pageIndex = 0; pageIndex < MAX_FETCH_PAGES; pageIndex += 1) {
        const page = await fetchPage(cursor);
        items.push(...page.items);

        if (!page.pageInfo.hasNextPage) {
            return items;
        }

        const nextCursor = page.pageInfo.cursor;
        if (!nextCursor || seenCursors.has(nextCursor)) {
            throw new Error("Pagination returned an invalid continuation cursor");
        }

        seenCursors.add(nextCursor);
        cursor = nextCursor;
    }

    throw new Error(`Pagination exceeded ${MAX_FETCH_PAGES} pages`);
}
